import { Box } from '@mui/material';
import React from 'react';
import Icon from 'components/Icon';
import { IconBoxProps } from './types';

const IconBox = ({
  icon,
  iconColor,
  iconBackground,
  boxSize = '40px',
  iconSize = '24px',
  borderRadius = ' 12px'
}: IconBoxProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: borderRadius,
        background: iconBackground,
        width: boxSize,
        height: boxSize,
        alignSelf: 'center',
        'svg *': { stroke: iconColor }
      }}
    >
      {icon && <Icon size={iconSize} name={icon} styles={{ stroke: iconColor, paintOrder: 'stroke' }} />}
    </Box>
  );
};

export default IconBox;
